<template>
  <div 
    class="grid grid-rows-[auto_1fr_auto] grid-cols-[auto] gap-0.5 p-2 rounded-r-lg rounded-bl-lg" 
    :class="contentOpen ? 'bg-gray-500/10':'bg-gray-500/5 text-default/10 dark:text-white/10'"
  >
    <div class="inline-flex justify-between">
      <span class="font-bold text-xxs underline mb-0.5">
        {{ comment.author.person.name }}:
      </span>

      <template v-if="comment.trashed">
        <rpm-button
          v-if="!contentOpen"
          color="transparent"
          tooltip-text="revelar"
          font-class="text-xxs"
          icon="fa-solid fa-eye"
          @click="contentOpen = !contentOpen"
        ></rpm-button>
        
        <rpm-button
          v-else
          color="transparent"
          tooltip-text="ocultar"
          font-class="text-xxs"
          icon="fa-solid fa-eye-slash"
          @click="contentOpen = !contentOpen"
        ></rpm-button>
      </template>
      <rpm-button
        v-else
        color-class="hover:text-red-500 text-default dark:text-white"
        tooltip-text="excluir"
        font-class="text-xxs"
        icon="fa-solid fa-trash"
        @click="$emit('delete', comment.id)"
      ></rpm-button>
    </div>

    <div class="text-sm">
      {{ contentOpen ? comment.content:'Mensagem apagada' }}
    </div>
    
    <span class="text-xxs text-right">
      {{ formatDate(comment.created_at, 'DD/MM/YYYY hh:mm') }}
    </span>
  </div>
</template>


<script>

import {formatDate} from "#functions/formatter.js";

export default {
  name: "Comment",
  data() {
    return {
      contentOpen: true
    };
  },
  props: {
    comment: {
      type: Object, 
      default: {}
    }
  },
  methods: {
    formatDate(...params){
      return formatDate(...params);
    },
  },
  created(){
    this.contentOpen = !this.comment.trashed;
  },
  watch: {
    'comment.trashed'(newer){
      this.contentOpen = !newer;
    }
  }
};
</script>